<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <!-- 操作按钮区域 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-button 
              type="primary" 
              size="medium" 
              class="action-btn primary-btn"
              @click="addButton()">
              <i class="el-icon-plus"></i>
              添加成员
            </el-button>
          </div>
        </div>

        <!-- 搜索区域 -->
        <div class="search-card">
          <div class="search-header">
            <h3 class="search-title">
              <i class="el-icon-search"></i>
              搜索筛选
            </h3>
          </div>
          <div class="search-content">
            <el-form size="medium" :inline="true" :model="searchCondition" class="search-form">
              <div class="form-row">
                <div class="form-item">
                  <label class="form-label">邮箱</label>
                  <div class="input-wrapper">
                    <el-input 
                      v-model="searchCondition.user_email" 
                      placeholder="输入邮箱搜索"
                      prefix-icon="el-icon-message"
                      clearable>
                    </el-input>
                  </div>
                </div>
                <div class="form-item" style="margin-left: 20px;">
                  <div class="button-group">
                    <el-button 
                      type="primary" 
                      size="medium"
                      class="search-btn"
                      @click="searchButton">
                      <i class="el-icon-search"></i>
                      查询
                    </el-button>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </div>

        <!-- 表格区域 -->
        <div class="table-card">
          <div class="table-header">
            <h3 class="table-title">
              <i class="el-icon-s-grid"></i>
              成员列表
            </h3>
            <div class="table-tools">
              <span class="data-count">共 {{pagingData.total || userList.length}} 条数据</span>
            </div>
          </div>
          <div class="table-content">
            <div class="modern-table">
              <ApeTable ref="apeTable" :data="userList" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
                <el-table-column
                  slot="first-column"
                  width="64"
                  label="序号"
                  align="center">
                  <template slot-scope="scope">
                    <div class="serial-number">{{offset+scope.$index+1}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="用户信息"
                  min-width="200">
                  <template slot-scope="scope">
                    <div class="user-cell">
                      <div class="user-name">
                        <i class="el-icon-user"></i>
                        {{scope.row.user_name}}
                      </div>
                      <div class="user-email">
                        <i class="el-icon-message"></i>
                        {{scope.row.user_email}}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="二次验证"
                  width="220"
                  align="center">
                  <template slot-scope="scope">
                    <img
                      v-if="scope.row.authcode_img"
                      :src="scope.row.authcode_img"
                      class="auth-code-img"
                      alt="OTP QR Code">
                    <span v-else class="otp-placeholder">未开启</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="状态"
                  width="120"
                  align="center">
                  <template slot-scope="scope">
                    <div class="status-cell">
                      <el-switch 
                        v-model="scope.row.allow_login" 
                        active-value="1" 
                        inactive-value="0"
                        active-color="#67C23A"
                        inactive-color="#F56C6C"
                        class="status-switch"
                        @change="rowSubmit(scope.row)">
                      </el-switch>
                      <div class="switch-label">
                        <i class="el-icon-success" v-if="scope.row.allow_login == '1'"></i>
                        <i class="el-icon-error" v-else></i>
                        {{ scope.row.allow_login == '1' ? '启用' : '禁用' }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="buttonType=='icon'"
                  width="220"
                  label="操作"
                  align="center">
                  <template slot-scope="scope">
                    <div class="action-cell">
                      <el-tooltip effect="dark" content="编辑" placement="top-start">
                        <el-button
                          type="primary"
                          size="mini"
                          icon="el-icon-edit"
                          class="table-action-btn edit-btn"
                          @click="editButton(scope.row.id)">
                        </el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="重置验证码" placement="top-start">
                        <el-button
                          type="warning"
                          size="mini"
                          icon="el-icon-refresh"
                          class="table-action-btn reset-btn"
                          @click="resetAuthCode(scope.row)">
                        </el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="移除" placement="top-start">
                        <el-popconfirm
                          title="确定要删除这个成员吗？"
                          @onConfirm="deleteButton(scope.row.id)">
                          <el-button
                            slot="reference"
                            type="danger"
                            size="mini"
                            icon="el-icon-s-promotion"
                            class="table-action-btn delete-btn">
                          </el-button>
                        </el-popconfirm>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="buttonType=='text'"
                  label="操作"
                  align="center">
                  <template slot-scope="scope">
                    <div class="action-cell">
                      <el-button 
                        size="mini"
                        type="primary"
                        v-if="userPermissions.indexOf('admin_edit') != -1" 
                        @click="editButton(scope.row.id)">
                        编辑
                      </el-button>
                      <el-button
                        size="mini"
                        type="warning"
                        v-if="userPermissions.indexOf('admin_edit') != -1"
                        @click="resetAuthCode(scope.row)">
                        重置验证码
                      </el-button>
                      <el-popconfirm
                        v-if="userPermissions.indexOf('admin_delete') != -1"
                        title="确定要删除这个成员吗？"
                        @onConfirm="deleteButton(scope.row.id)">
                        <el-button 
                          slot="reference" 
                          type="danger" 
                          size="mini">
                          删除
                        </el-button>
                      </el-popconfirm>
                    </div>
                  </template>
                </el-table-column>
              </ApeTable>
            </div>
          </div>
        </div>
      </div>
    </PageHeaderLayout>

    <ApeDrawer :drawerData="drawerData"  @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="formRules" ref="userForm" label-position="right" label-width="96px">
          <el-row>
            <el-col :span="22">
              <el-form-item label="用户名" prop="username">
                <el-input v-model="formData.username"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="手机号" prop="mobile">
                <el-input v-model="formData.mobile"  maxlength="11"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="Email" prop="email">
                <el-input v-model="formData.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="密码" prop="password">
                <el-input v-model="formData.password" type="password" :placeholder="formData.id ? '留空则不修改密码' : '请输入密码'"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="头像"> 
                 <ApeUploader :limit="1" @handleUploadSuccess="handleUploadSuccess" @handleUploadRemove="handleUploadRemove" :upload-file-list="uploadFileList"></ApeUploader> 
              </el-form-item>
            </el-col>
          </el-row>
           <el-row>
            <el-col :span="22">
              <el-form-item label="二次验证码">
                <img
                  v-if="formData.authcode_img"
                  :src="formData.authcode_img"
                  class="auth-code-img"
                  alt="OTP QR Code">
                <span v-else class="otp-placeholder">站点未开启 OTP 或尚未生成二维码</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>     
      </template>
    </ApeDrawer>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import ApeUploader from '@/components/ApeUploader'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeUploader
  },
  data() {
    return {
      // 搜索条件
      searchAdminCondition:{
        current_page: 1,
        page_size: 200,
        query: "",
        params: [],
      },
      loadingStaus: true,
      columns: [
        {
          title: '用户名',
          value: 'Items.username',
          width: 240
        },
        {
          title: '手机号',
          value: 'Items.mobile'
        },
        {
          title: '邮箱',
          value: 'Items.email'
        },
      ],
      uploadFileList:[],
      // 表格列表数据
      userList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        avatar:''
      },
      // 表单验证
      rules: {
        mobile: [{required: true, message: '输入手机号', trigger: 'blur' },{pattern: this.$utils.regular.mobile,message:'手机号格式错误', trigger: 'blur' }],
        username: [{max:20,min:6,required: true,message:'用户名格式6-20位英文数字', trigger: 'blur' }],
        email: [{ type: 'email',max:20,min:6, required: true,message:'邮箱为6-20位', trigger: 'blur' }],
        password: [
          { pattern:/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){8,20}$/,required: true, message: '必须输入8-20且字母、数字和标点符号至少包含两种', trigger: 'blur' }
        ],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '480px',
      },
      searchCondition:{
        current_page: 1,
        page_size: 20,
        user_email: '',
        role_id: ''
      },
      rolesList: [],
      userRoles: []
      
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType']),
    formRules() {
      const rules = { ...this.rules }
      if (this.formData && this.formData.id) {
        rules.password = [
          { pattern:/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){8,20}$/, required: false, message: '必须输入8-20且字母、数字和标点符号至少包含两种', trigger: 'blur' }
        ]
      }
      return rules
    }
  },
  methods: {
    // 搜索
    searchButton() {
      this.searchCondition.current_page = 1
      this.initAdminList()
    },
    // 切换页码操作
    async switchPaging() {
      this.initAdminList()
    },
    // 响应添加按钮
    async addButton() {
      this.uploadFileList=[]
      this.formData = {}
      this.drawerData.visible = true
      this.drawerData.title = '添加用户'
      this.drawerData.loading = false
    },
    // 响应编辑按钮
    async editButton(id) {
      this.uploadFileList=[]
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑用户(UID：'+id+')'
      let {info} = await this.$api.getAdminInfo(id)
      this.formData = Object.assign({}, info, {
        username: info.username || info.user_name,
        email: info.email || info.user_email,
        mobile: info.mobile || info.user_mobile,
        avatar: info.avatar || info.user_avatar,
        password: ''
      })
      if (this.formData.avatar) {
        this.uploadFileList = [{id: info.id, name: this.formData.username, url: this.formData.avatar}]
      }
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.rolesList = []
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      const payload = Object.assign({}, this.formData)
      if (!payload.id) {
        payload.role_id = this.$route.params.id
      }
      if (payload.id && !payload.password) {
        delete payload.password
      }
      let id = await this.$api.saveAdmin(payload)
      this.$nextTick(() => {
        this.drawerData.visible = false
      })
      this.$nextTick(async () => {
        if (id) {
          this.initAdminList()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
      this.initFormData()
    },
    // row数据提交，请求接口
    async rowSubmit(row) {
      const id = await this.$api.saveAdmin({
        id: row.id,
        allow_login: row.allow_login
      })
      if (id) {
        this.$message.success('保存成功!')
        this.initAdminList()
      }
    },
    async resetAuthCode(row) {
      const detail = await this.$api.resetAdminOtp(row.id)
      if (detail) {
        this.$message.success('验证码已重置')
        this.initAdminList()
      }
    },
    // 相应删除按钮
    async deleteButton(id) {
      let info = await this.$api.deleteAdmin(id)
      if (info.id == id) {
        this.$nextTick(async () => {
          this.initAdminList()
        })
      } else {
        this.$message.error(info)
      }
      
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {user_role:{system_role_id:0}}
        this.$refs['userForm'].resetFields()
      })
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.avatar = file
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.image = 0
      this.uploadFileList = fileList
    },
    // 初始化用户列表
    async initAdminList(type) {
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      Object.assign(this.searchCondition, pagingInfo)
      this.searchCondition.role_id = this.$route.params.id
      let res = await this.$api.post("/service/role/members", this.searchCondition)
      if (this.$apiSuccess(res)) {
        this.userList = res.data.list || []
        const page = res.data.page || {}
        this.pagingData.total = page.total || 0
        const pageSize = Number(this.searchCondition.page_size) || 20
        const currentPage = Number(this.searchCondition.current_page) || 1
        this.offset = (currentPage - 1) * pageSize
      } else {
        this.$message.error(res.message || '加载成员列表失败')
      }
      this.loadingStaus=false
    },
  },
  mounted() {
    this.initAdminList()
  },
}
</script>

<style lang="stylus" scoped>
.main-page-content
  padding 0
  
// 页面标题区域
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  padding 32px
  margin-bottom 24px
  border-radius 12px
  color #fff
  
  .title-content
    .page-title
      font-size 28px
      font-weight 600
      margin 0 0 8px 0
      display flex
      align-items center
      gap 12px
      
      i
        font-size 32px
        opacity 0.9
        
    .page-subtitle
      font-size 16px
      opacity 0.9
      margin 0

// 操作卡片
.action-card
  background #fff
  border-radius 12px
  padding 24px
  margin-bottom 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .action-header
    margin-bottom 16px
    
    .action-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
  .action-buttons
    display flex
    gap 12px
    
    .action-btn
      height 40px
      padding 0 20px
      border-radius 8px
      font-weight 500
      transition all 0.3s ease
      
      &.primary-btn
        background linear-gradient(135deg, #409EFF 0%, #66B3FF 100%)
        border none
        box-shadow 0 4px 12px rgba(64,158,255,0.3)
        
        &:hover
          transform translateY(-2px)
          box-shadow 0 6px 16px rgba(64,158,255,0.4)

// 搜索卡片
.search-card
  background #fff
  border-radius 12px
  padding 24px
  margin-bottom 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .search-header
    margin-bottom 20px
    border-bottom 1px solid #f0f0f0
    padding-bottom 12px
    
    .search-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
  .search-content
    .search-form
      .form-row
        display flex
        flex-wrap wrap
        gap 16px
        align-items flex-end
        
        .form-item
          flex none
          margin-bottom 16px
          
          .form-label
            display block
            font-size 14px
            color #606266
            margin-bottom 8px
            font-weight 500
            
          .input-wrapper
            /deep/ .el-input
              width 200px
              
              .el-input__inner
                border-radius 8px
                border 2px solid #f0f0f0
                transition all 0.3s ease
                
                &:focus
                  border-color #409EFF
                  box-shadow 0 0 0 2px rgba(64,158,255,0.1)
                  
          .button-group
            display flex
            gap 8px
            
            .search-btn
              background linear-gradient(135deg, #409EFF 0%, #66B3FF 100%)
              border none
              border-radius 8px
              padding 10px 20px
              font-weight 500
              box-shadow 0 2px 8px rgba(64,158,255,0.3)
              
              &:hover
                transform translateY(-1px)
                box-shadow 0 4px 12px rgba(64,158,255,0.4)

// 表格卡片
.table-card
  background #fff
  border-radius 12px
  padding 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .table-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 1px solid #f0f0f0
    
    .table-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
    .table-tools
      .data-count
        color #909399
        font-size 14px

// 表格样式
.modern-table
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    .el-table__header
      background #f8f9fa
      
      th
        background #f8f9fa !important
        color #303133
        font-weight 600
        border-bottom 2px solid #e4e7ed
        
    .el-table__body
      tr
        transition all 0.3s ease
        
        &:hover
          background-color #f5f7fa
          
        td
          border-bottom 1px solid #f0f0f0

// 表格单元格样式
.serial-number
  font-weight 600
  color #606266
  background #f8f9fa
  padding 4px 8px
  border-radius 4px
  display inline-block
  min-width 28px
  text-align center

.user-cell
  .user-name
    font-size 16px
    font-weight 600
    color #303133
    margin-bottom 6px
    display flex
    align-items center
    gap 8px
    
    i
      color #409EFF
      
  .user-email
    font-size 14px
    color #909399
    display flex
    align-items center
    gap 6px
    
    i
      color #67C23A

.status-cell
  display flex
  flex-direction column
  align-items center
  gap 8px
  
  .status-switch
    /deep/ .el-switch__core
      border-radius 10px
      
  .switch-label
    font-size 12px
    color #909399
    display flex
    align-items center
    gap 4px
    
    i
      font-size 14px

.action-cell
  display flex
  gap 6px
  justify-content center
  flex-wrap wrap

.auth-code-img
  width 200px
  height 200px
  object-fit contain
  border 1px solid #f0f0f0
  border-radius 8px
  background #fff

.otp-placeholder
  color #909399
  font-size 12px
  
  .table-action-btn
    width 28px
    height 28px
    border-radius 6px
    padding 0
    display inline-flex
    align-items center
    justify-content center
    transition all 0.3s ease
    
    &.delete-btn
      background #F56C6C
      border-color #F56C6C
      
      &:hover
        background #F78989
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(245,108,108,0.3)

// 响应式设计
@media (max-width: 768px)
  .page-title-section
    padding 20px
    
    .title-content
      .page-title
        font-size 24px
        
  .action-card, .search-card, .table-card
    padding 16px
    
  .action-buttons
    flex-direction column
    
    .action-btn
      width 100%
      margin-bottom 8px
      
  .search-content
    .search-form
      .form-row
        flex-direction column
        align-items stretch
        
        .form-item
          width 100%
          
          .input-wrapper
            /deep/ .el-input
              width 100%
</style>
